import OperationButtons from "./OperationButtons";

const Menu = () => {
  return <OperationButtons />;
};

export default Menu;
